import * as FileSaver from "file-saver"
import XLSX from "sheetjs-style"



const exportExcel = (excelData, fileName) => {
    console.log(excelData, fileName)
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension='.xlsx';

    const exportToExcel = async () => {
        const ws = XLSX.utils.json_to_sheet(excelData);

         // Make headers bold
        ws['!rows'] = ws['!rows'] || [];
        ws['!rows'][0] = { hidden: false, hpt: 20, hpx: 20, level: 0, outline: false, collapsed: false };
        ws['!cols'] = ws['!cols'] || [];
        Object.keys(excelData[0]).forEach((key, colIndex) => {
            ws['!cols'][colIndex] = { hidden: false, width: 20 };
            ws['!rows'][0][colIndex] = { hidden: false, hpt: 20, hpx: 20, level: 0, outline: false, collapsed: false };
            ws[XLSX.utils.encode_cell({ r: 0, c: colIndex })] = {
                t: 's',
                v: key,
                s: { font: { bold: true } } // Make the font bold
            };
        });

        const wb = {Sheets: {'data':ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type:'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName+fileExtension);
    }

    exportToExcel()

}

export default exportExcel;